<template>
    <q-layout view="hHh lpR fFf">
        <q-header elevated class="bg-indigo text-white">
            <q-toolbar>
                <!-- <q-btn dense flat round icon="menu" @click="toggleLeftDrawer" /> -->
                <q-btn
                    dense
                    flat
                    round
                    icon="arrow_back"
                    @click="goBack"
                    v-if="routeName != 'Home'"
                />

                <q-toolbar-title> Newlife </q-toolbar-title>

                <!-- <router-link
                    v-if="routeName == 'Home'"
                    :to="{ name: 'NewAppointment' }"
                >
                    <q-btn
                        color="white"
                        dense
                        flat
                        round
                        icon="calendar_month"
                    />
                </router-link> -->

                <q-btn
                    color="white"
                    dense
                    flat
                    round
                    icon="logout"
                    @click="logout"
                />
            </q-toolbar>
        </q-header>

        <q-drawer v-model="leftDrawerOpen" side="left" bordered>
            <!-- drawer content -->
        </q-drawer>

        <q-page-container>
            <q-page padding>
                <div class="row justify-center" v-if="routeName == 'Home'">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <div class="row justify-center">
                            <q-btn
                                label="New Message"
                                color="indigo"
                                class="col"
                                icon="mail"
                                @click="goToNewMessgae"
                                style="width: 100%; margin-bottom: 4px"
                            ></q-btn>

                            <div
                                style="width: 10px"
                                v-if="selectedThread !== null"
                            />

                            <!-- <q-btn-group  
                                        v-show="selectedThread !== null">

                                    <q-btn
                                        label="Delete"
                                        color="red"
                                    ></q-btn>

                                    <q-btn color="red" rounded icon="close" />
                                    
                                </q-btn-group> -->
                            <q-btn
                                label="Delete"
                                color="red"
                                v-show="selectedThread !== null"
                                class="col"
                                icon="delete"
                                :disable="selectedThread == null"
                                @click="deleteThread"
                                style="width: 100%; margin-bottom: 4px"
                            ></q-btn>

                            <!-- <q-fab
                                    v-model="actionBtn"
                                    vertical-actions-align="center"
                                    color="indigo"
                                    icon="add"
                                    direction="up"
                                    class="q-mr-sm"
                                >
                                    <q-fab-action
                                        external-label
                                        label-position="left"
                                        label="New Message"
                                        color="indigo-14"
                                        icon="mail"
                                        @click="goToNewMessgae"
                                    ></q-fab-action>
                                    <q-fab-action
                                        external-label
                                        label-position="left"
                                        label="Delete"
                                        color="indigo-14"
                                        icon="delete"
                                        :disable="selectedThread == null"
                                        @click="deleteThread"
                                    ></q-fab-action>
                                </q-fab> -->
                        </div>
                    </div>
                </div>

                <div class="row justify-center">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <router-view />
                    </div>
                </div>
            </q-page>
        </q-page-container>

        <q-footer class="bg-white text-black">
            <!-- <div class="row justify-center" v-if="routeName == 'Home'">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                    <div class="row justify-end">
                        <q-fab
                            v-model="actionBtn"
                            vertical-actions-align="center"
                            color="indigo"
                            icon="add"
                            direction="up"
                            class="q-mr-sm"
                        >
                            <q-fab-action
                                external-label
                                label-position="left"
                                label="New Message"
                                color="indigo-14"
                                icon="mail"
                                @click="goToNewMessgae"
                            ></q-fab-action>
                            <q-fab-action
                                external-label
                                label-position="left"
                                label="Delete"
                                color="indigo-14"
                                icon="delete"
                                :disable="selectedThread == null"
                                @click="deleteThread"
                            ></q-fab-action>
                        </q-fab>
                    </div>
                </div>
            </div> -->

            <div class="row justify-center">
                <template v-if="routeName == 'ComposeMessage'">
                    <q-toolbar class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <q-space />

                        <q-btn
                            label="Send"
                            color="indigo"
                            outline
                            style="width: 100%"
                            @click="composeMessage"
                        ></q-btn>

                        <q-space />
                    </q-toolbar>
                </template>

                <template v-if="routeName == 'Home'">
                    <q-toolbar class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <q-space />
                        <router-link
                            :to="{ name: 'RequestAppointment' }"
                            class="col"
                        >
                            <q-btn
                                label="Request Appointment"
                                color="indigo"
                                outline
                                style="width: 100%"
                            ></q-btn>
                        </router-link>
                        <div style="width: 10px"></div>
                        <router-link
                            :to="{ name: 'ScheduledAppointment' }"
                            class="col"
                        >
                            <q-btn
                                label="Scheduled Appointment"
                                color="indigo"
                                outline
                                style="width: 100%"
                            ></q-btn>
                        </router-link>
                        <q-space />
                    </q-toolbar>
                </template>

                <template v-if="routeName == 'Messages'">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <q-input
                            v-model="messageInput"
                            outlined
                            autogrow
                            autofocus
                            type="textarea"
                        >
                            <template v-slot:after>
                                <q-btn
                                    round
                                    dense
                                    flat
                                    icon="send"
                                    @click="sendMsg"
                                ></q-btn>
                            </template>
                        </q-input>
                    </div>
                </template>
            </div>
        </q-footer>
    </q-layout>
</template>

<script>
import { computed } from "@vue/reactivity";
import { onMounted, onUnmounted, provide, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { emitter } from "../main";

export default {
    setup() {
        const leftDrawerOpen = ref(false);
        const route = useRoute();
        const router = useRouter();
        const routeName = computed(() => route.name);
        const actionBtn = ref(false);

        const selectedThread = ref(null);
        provide("selectedThread", selectedThread);

        const messageInput = ref();
        provide("messageInput", messageInput);

        const goBack = () => {
            router.go(-1);
        };

        const logout = () => {
            localStorage.removeItem("USER");
            location.reload();
        };

        return {
            leftDrawerOpen,
            routeName,
            goBack,
            messageInput,
            toggleLeftDrawer() {
                leftDrawerOpen.value = !leftDrawerOpen.value;
            },
            sendMsg: () => {
                emitter.emit("send-message");
            },
            composeMessage: () => {
                emitter.emit("compose-message");
            },
            logout,
            selectedThread,
            actionBtn,
            goToNewMessgae: () => {
                router.push({ name: "ComposeMessage" });
            },
            deleteThread: () => {
                emitter.emit("delete-thread");
            },
        };
    },
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
